import
  React, {
  useEffect,
  useState
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import
  styled
from 'styled-components';

import {
  HContainer,
  HFillContainerVH,
  Image,
  JourneyProvider,
  Spinner,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../constants';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

import {
  DrupalProvider
} from 'providers';

import {
  isEqual
} from 'helpers';

const PageContainer = styled(VContainer)`
  overflow-x: hidden;
  overflow-wrap: break-word;
`;

const OnboardingLegalUI = props => {

  const history = useHistory();

  const mountedRef = React.useRef(true);

  const getPage = async () => {

    const response = await DrupalProvider.getCachedItem('pages', null, DrupalProvider.getPages);

    if (!mountedRef.current) {
      return;
    }

    if (response?.result) {
      setState({
        ...state,
        loading: false
      });
      setPage(response.result.find(page => isEqual(page.title, 'Terms & Conditions')));
    }
  };

  const [ page, setPage ] = useState(null);
  const [ state, setState ] = useState({
    loading: true,
    hasError: false,
    error: null
  });

  useEffect(() => {

    const init = async () => {
      await getPage();
    };

    init();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return (

    <>
          {
        state.loading &&
        <HFillContainerVH height='100vh'>

          <Spinner color={CustomColors.Red1} duration={2.5} size='200' />
        </HFillContainerVH>
      }

      {
        page &&
    <PageContainer
      height={'100%'}
      padding={'43px 16px 39px'}>

        <HContainer
          key={'landing-page-logo'}>

          <VContainer
            margin={'0 16px 16px 0'}>

            <Image
              src={Icons.VodacomLogo}
              width={'50px'}
              height={'50px'}
              margin={'0 17px 0 0'}/>

          </VContainer>

          <Image
            src={Icons.ConnectU}
            width={'164px'}
            height={'40px'}/>

        </HContainer>

        <Text
          fontSize={'16px'}
          dangerouslySetInnerHTML={{ __html: page.content }}/>

        <PrimaryButton
          text={'Accept terms & conditions'}
          onClick={() => {

            JourneyProvider.set('Common', { acceptedLanding: true }, true);
            history.push('/home');
          }}/>

        <SecondaryButton
          text={'Cancel'}
          margin={'24px 0 0'}
          onClick={() => history.push('/landing')}/>

    </PageContainer>
}
    </>
  );
};

OnboardingLegalUI.pageName = 'cbu: connectu: agree to terms and conditions';

export const OnboardingLegal = withScreenViewTagging(OnboardingLegalUI);